module.exports = __webpack_public_path__ + "svg_80x80/sinatra.78e21b.svg";